var buttonSize = {
  small: {
    height: 32,
    padding: 8
  },
  medium: {
    height: 36,
    padding: 10
  },
  large: {
    height: 44,
    padding: 14
  }
};
export default buttonSize;